import { render, staticRenderFns } from "./FlatsTable.vue?vue&type=template&id=518b083e&scoped=true"
import script from "./FlatsTable.vue?vue&type=script&lang=js"
export * from "./FlatsTable.vue?vue&type=script&lang=js"
import style0 from "./FlatsTable.vue?vue&type=style&index=0&id=518b083e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b083e",
  null
  
)

export default component.exports